import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionPillar from "@/pages/SolutionPillar";

export const Route = createFileRoute("/es/soluciones/$pillarSlug")({
  head: ({ params }) => buildRouteHead(`/es/soluciones/${params.pillarSlug}`),
  component: SolutionPillar,
});

